import dayjs from 'dayjs';

import { useTranslation } from '@/i18n/client';
import { WithLang } from '@/types/general';

export const EventCardDate = (props: WithLang<{ dayString: string }>) => {
    const { t } = useTranslation(props.lang, 'calendar');
    const day = dayjs(props.dayString);
    return (
        <p className={`my-6 text-xl font-semibold xs:text-2xl`}>
            {t('formats.dayMonthYearWeekday', {
                day: day.date(),
                month: day.month(),
                year: day.year(),
                weekday: day.day(),
            })}
        </p>
    );
};
